import { List as ImmutableList } from 'immutable';
import { ImmutableObject } from 'common/state/interfaces';
import { IPaginatedData } from 'common/interfaces/pagination';
import { IEventPersonEntityImt } from 'modules/booking/interfaces';
import { IEmployeeBasicInfoImt, INamedEntity, INamedEntityImt } from 'common/interfaces/common';
import { IEmployeeBasicInfo } from 'interfaces/employee.interfaces';

export enum AppointmentReportStatuses {
  CANCELED = 'CANCELED',
  DELETED = 'DELETED',
}

interface IAppointmentResourceItem extends INamedEntity {
  employee: IEmployeeBasicInfo;
}

export interface IAppointmentResourceItemImt extends ImmutableObject<IAppointmentResourceItem> {
  get<K extends keyof IAppointmentResourceItem>(key: K): IAppointmentResourceItem[K];
  get(key: 'employee'): IEmployeeBasicInfoImt;
}

export interface IAppointmentItem {
  date: string;
  id: string;
  name: string;
  participants: number;
  resources: IAppointmentResourceItem[];
  spotAmount: number;
  spotLimited: boolean;
  attended: number;
  tags: INamedEntity[];
  canceled: boolean;
  deleted: boolean;
  personsAttended: number;
  personsCanceled: number;
  personsConfirmed: number;
  personsMissed: number;
  personsPending: number;
}

export interface IAppointmentItemImt extends ImmutableObject<IAppointmentItem> {
  get<K extends keyof IAppointmentItem>(key: K): IAppointmentItem[K];

  get(key: 'participants'): IEventPersonEntityImt;
  get(key: 'resources'): ImmutableList<IAppointmentResourceItemImt>;
  get(key: 'tags'): ImmutableList<INamedEntityImt>;
}

export type IPaginatedAppointments = IPaginatedData<IAppointmentItem>;
